import { AppService } from "app/services/app.service";

import { Observable } from "rxjs";

export abstract class AbDownload extends AppService {
  abstract downloadArquivoByBase64(base64: string, nomeAnexo: string): Observable<any>;
  abstract downloadArquivoByBlob(blob: Blob, nomeAnexo: string): Observable<any>;
  abstract validarArquivo(files, limitUpload, arquivos): boolean;
}
